
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M192 0C86.112 0 0 86.112 0 192c0 133.088 173.312 307.936 180.672 315.328a16.07 16.07 0 0022.656 0s14.08-14.048 34.016-36.96c5.824-6.656 5.12-16.768-1.536-22.592-6.624-5.76-16.704-5.088-22.592 1.536-8.384 9.6-15.68 17.6-21.216 23.52C153.792 432 32 293.664 32 192c0-88.224 71.776-160 160-160s160 71.776 160 160c0 4.576-.256 9.44-1.056 14.304-1.472 8.704 4.384 16.96 13.12 18.432 8.608 1.376 16.992-4.416 18.432-13.12C383.616 204.96 384 198.304 384 192 384 86.112 297.888 0 192 0z"}}),_c('path',{attrs:{"d":"M192 96c-52.928 0-96 43.072-96 96s43.072 96 96 96 96-43.072 96-96-43.072-96-96-96zm0 160c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64zM384 256c-70.592 0-128 57.408-128 128s57.408 128 128 128 128-57.408 128-128-57.408-128-128-128zm0 224c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"}}),_c('path',{attrs:{"d":"M443.36 340.704c-6.24-6.24-16.416-6.272-22.688-.032L368 393.376l-20.672-20.672c-6.24-6.24-16.384-6.24-22.624 0s-6.24 16.384 0 22.624l32 32c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l64-64c6.24-6.24 6.24-16.384 0-22.624z"}})])
          )
        }
      }
    